module.exports = __webpack_public_path__ + "img/bi.438f75a9.svg";